import React from "react";
import Tips from "../components/Tips";

const Tipspage = () => {
    return (
        <>            
            <div className='flex flex-col h-screen font-primary'>
                <Tips/>
            </div>
        </>
    );
};

export default Tipspage